var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Wrapper from '../../../Components/Wrapper/Wrapper';
import Transition from '../../../Components/Transition/Transition';
import Header from '../../../Components/Header';
import GoBack from '../../../Components/GoBack/GoBack';
import useApiAbort from '../../../Api/Core/useApiAbort';
import { MakhazinTheme } from '../../../theme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useStyles } from './StorageActivity.styles';
import { useApi } from '../../../Context/APIContext';
import { Box } from '@mui/material';
import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
const activityMap = {
    Unlock: 'Upplåst',
    Lock: 'Låst',
    UnauthorizedDoorOpen: 'Oväntad dörröppning',
    DoorOpen: 'Dörren öppnad efter upplåsning av användaren',
    DoorClosed: 'Dörren stängd',
    FireAlarm: 'Brandlarm',
    FireAlarmOff: 'Brandlarm avstängt',
    TurnLightOn: 'Lampan tänd',
    TurnLightOff: 'Lampan släckt',
};
const fetchActivityList = (api, storageId) => __awaiter(void 0, void 0, void 0, function* () {
    if (api && storageId) {
        var response = yield api.getActivities(storageId);
        return response.activities;
    }
    else {
        return undefined;
    }
});
export const StorageActivity = (props) => {
    const abortController = useApiAbort();
    const smDown = useMediaQuery(MakhazinTheme.breakpoints.down('sm'));
    const classes = useStyles();
    const api = useApi();
    if (api) {
        api.setAbortController(abortController.current);
    }
    const [activityLog, setActivityLog] = useState(undefined);
    const fetchActivityLog = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield fetchActivityList(api, props.storageId);
        setActivityLog(result);
    }), [api, props.storageId]);
    useEffect(() => {
        fetchActivityLog();
    }, [fetchActivityLog]);
    return (React.createElement(Transition, { isLoading: activityLog === undefined },
        React.createElement(Header, null,
            React.createElement(GoBack, { to: `/mypages/mystorage/${props.storageId}` }),
            React.createElement(Typography, { variant: "h1", sx: classes.title },
                "Aktivitet - ",
                props.containerCode,
                " - ",
                props.storageCode)),
        React.createElement(Wrapper, null,
            React.createElement(Typography, { variant: "h5", sx: classes.heading }, "H\u00E4r kan du se alla h\u00E4ndelser f\u00F6r f\u00F6rr\u00E5dsutrymmet"),
            React.createElement(Box, { sx: classes.tableWrapper }, !smDown ? (React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null,
                            React.createElement("strong", null, "Tidpunkt")),
                        React.createElement(TableCell, null,
                            React.createElement("strong", null, "Aktivitet")),
                        React.createElement(TableCell, null,
                            React.createElement("strong", null, "Anv\u00E4ndare")))),
                React.createElement(TableBody, null, activityLog &&
                    activityLog.map(activity => (React.createElement(TableRow, { key: activity.timestamp },
                        React.createElement(TableCell, null, format(new Date(activity.timestamp), 'PPPp', { locale: sv })),
                        React.createElement(TableCell, null, activityMap[activity.text]),
                        React.createElement(TableCell, null, activity.user))))))) : (React.createElement(Box, { component: "div" },
                ' ',
                activityLog &&
                    activityLog.map(activity => (React.createElement(Box, { component: "div", key: activity.timestamp, sx: classes.activity },
                        React.createElement(Grid, { container: true },
                            React.createElement(Box, { component: "span", sx: classes.activityName }, activityMap[activity.text]),
                            React.createElement(Box, { component: "span" },
                                "(",
                                format(new Date(activity.timestamp), 'PPPp', { locale: sv }),
                                ")")),
                        React.createElement(Box, { component: "span" }, activity.user))))))))));
};
export default StorageActivity;
